import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import {
    Box,
    Heading,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    Button
} from '@chakra-ui/react';

import { AnimalClass } from '../../../core/animal';
import { RoleClass } from '../../../core/land';

import { PageCard, PageCardFooter } from '../shared';

export default function AnimalCardHealth(props: {
    data: AnimalClass;
    role: RoleClass;
}): React.ReactElement {
    const [animal, setAnimal] = useState<AnimalClass>();
    const isEdit = props.data !== undefined;

    useEffect(() => {
        setAnimal(props.data);
    }, []);

    return animal ? (
        <PageCard id='heathCard'>
            <Heading size='md'>
                {t('animal.healthy.data', 'Salud') as string}
            </Heading>
            <Box my='4'>
                <Tabs size='md' variant='line' isFitted px='1'>
                    <TabList>
                        <Tab>Vacunas</Tab>
                        <Tab>Enfermedades</Tab>
                        <Tab>Fallecidos</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <p>Lista de valunas</p>
                            {!props.role?.isReader() ? (
                                <PageCardFooter>
                                    <Button
                                        size='sm'
                                        colorScheme='green'
                                        variant='outline'
                                    >
                                        {
                                            t(
                                                isEdit
                                                    ? 'form.edit'
                                                    : 'form.add'
                                            ) as string
                                        }{' '}
                                        - Vacuna
                                    </Button>
                                </PageCardFooter>
                            ) : (
                                <Box my='2'></Box>
                            )}
                        </TabPanel>
                        <TabPanel>
                            <p>Lista de enfermedades</p>
                            {!props.role?.isReader() ? (
                                <PageCardFooter>
                                    <Button
                                        size='sm'
                                        colorScheme='green'
                                        variant='outline'
                                    >
                                        {
                                            t(
                                                isEdit
                                                    ? 'form.edit'
                                                    : 'form.add'
                                            ) as string
                                        }{' '}
                                        - Enfermedad
                                    </Button>
                                </PageCardFooter>
                            ) : (
                                <Box my='2'></Box>
                            )}
                        </TabPanel>
                        <TabPanel>
                            <p>Animales fallecidos</p>
                            {!props.role?.isReader() ? (
                                <PageCardFooter>
                                    <Button
                                        size='sm'
                                        colorScheme='green'
                                        variant='outline'
                                    >
                                        {
                                            t(
                                                isEdit
                                                    ? 'form.edit'
                                                    : 'form.add'
                                            ) as string
                                        }{' '}
                                        - Fallecidos
                                    </Button>
                                </PageCardFooter>
                            ) : (
                                <Box my='2'></Box>
                            )}
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </PageCard>
    ) : (
        <></>
    );
}
